import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';
import PropTypes from 'prop-types';

/**
 * Reusable confirmation dialog component
 */
const ConfirmationDialog = ({ 
  open, 
  title, 
  message,
  itemName,
  onCancel, 
  onConfirm,
  cancelText = "Cancel",
  confirmText = "Confirm",
  confirmColor = "primary",
  destructive = false,
  dialogProps = {},
  ...props
}) => {
  // If destructive is true, override confirmColor to "error"
  const buttonColor = destructive ? "error" : confirmColor;
  
  // Format message with item name if provided
  const formattedMessage = itemName 
    ? message.replace("{itemName}", `"${itemName}"`)
    : message;

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
      onClick={(e) => e.stopPropagation()}
      PaperProps={{
        sx: { borderRadius: 2 }
      }}
      {...dialogProps}
      {...props}
    >
      <DialogTitle id="confirmation-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="confirmation-dialog-description">
          {formattedMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          {cancelText}
        </Button>
        <Button onClick={onConfirm} color={buttonColor} autoFocus>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  itemName: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  cancelText: PropTypes.string,
  confirmText: PropTypes.string,
  confirmColor: PropTypes.string,
  destructive: PropTypes.bool,
  dialogProps: PropTypes.object
};

export default ConfirmationDialog;